<template>
  <div class="d-flex flex-column flex-root">
    <div class="d-flex flex-column flex-lg-row flex-column-fluid justify-content-center bg-ubbi" style="background-color: #780f5a;">
      <div class="d-flex flex-column flex-center p-10">
        <div class="card card-flush w-lg-500px">
          <div class="card-body text-center py-10">
            <span class="spinner-border text-primary" v-if="loading"></span>
            <div v-else>
              <h3 class="text-danger">{{ errorMessage }}</h3>
              <a v-if="errorMessage" class="btn btn-primary mt-5" :href="siteUrl">Ir para o site</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../../config";
import { decodeInvitePayload } from "../../helpers/inviteLink";

export default {
  name: "InviteRedirect",
  data() {
    return {
      loading: true,
      errorMessage: '',
      siteUrl: Config.site_url_prof,
    };
  },
  mounted() {
    this.redirect();
  },
  methods: {
    redirect() {
      const encoded = this.$route.query.p;
      if (!encoded) {
        this.loading = false;
        this.errorMessage = 'Link de convite inválido.';
        return;
      }

      try {
        const payload = decodeInvitePayload(encoded);
        const action = payload.action || 'accept';
        const routeName = payload.kind === 'professional' ? 'InviteProfessionalAction' : 'InviteUserAction';

        this.$router.replace({
          name: routeName,
          params: {
            placeId: payload.placeId,
            inviteId: payload.inviteId,
            action,
          },
          query: {
            token: payload.token,
          },
        });
      } catch (error) {
        this.loading = false;
        this.errorMessage = 'Link de convite inválido ou expirado.';
      }
    },
  },
};
</script>
